import { intialMessage } from 'constants/ui.constants';
import {
	setAll,
	setAwaitingAuthorization,
	setLoading,
	setMessage,
	setOpenPending,
} from 'state/reducers/requests.reducers';
import API from 'services/api.services';
import { API_GET_OPEN_REQUESTS } from 'constants/db.constants';
import { BalanceType, StatusType } from 'constants/balance.constants';
import { BankAccountStatus } from 'constants/bank-account.constants';
import { BeneficiaryStatus } from 'constants/beneficiary.constants';
import { store } from 'state/store';
import { initialRequestData, PendingRequestTypes, requestData } from 'constants/requests.constants';
import _ from 'lodash';
import { PaymentStatus } from 'constants/pay.constants';
import { ContactStatus } from 'constants/contact.constants';
import { setErrorMessage } from 'utils';
import { PendingActivityTypes } from 'constants/activity.constants';

export function getOpenPendingRequestsByCompanyId() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setMessage(intialMessage));
		const paramsSetting = {
			companyId: store.getState().user.details?.companyId,
		};

		await API.getInstance()
			.get(API_GET_OPEN_REQUESTS, paramsSetting)
			.then((response) => {
				const requests = response.data.openPendingRequests;
				let openRequests: requestData = { ...initialRequestData };
				let awaitingAuthorization: requestData = { ...initialRequestData };
				let allRequests: requestData = { ...initialRequestData };
				Object.keys(requests).forEach((category) => {
					switch (category) {
						case 'bankAccountsRequests': {
							requests[category].forEach((bankAccountReq) => {
								let obj = {
									id: bankAccountReq.id,
									referenceNumber: bankAccountReq.reference,
									date: bankAccountReq.createdAt,
									holderName: bankAccountReq.accountOwnerName,
									bankName: bankAccountReq.bankName.bankName.trim(),
									branch: bankAccountReq.bankBranch,
									accountNumber: bankAccountReq.accountNumber,
									createdBy: bankAccountReq.createdBy,
									status: bankAccountReq.status,
									category: PendingRequestTypes.BANK_ACCOUNTS,
								};
								if (_.isEqual(bankAccountReq.status, BankAccountStatus.Pending)) {
									openRequests[category] = [...openRequests[category], obj];
								}
								allRequests[category] = [...allRequests[category], obj];
							});
							break;
						}
						case 'balancesRequests': {
							requests[category].forEach((balanceRequest) => {
								let obj = {
									id: balanceRequest.id,
									referenceNumber: balanceRequest.reference,
									date: balanceRequest.createdAt,
									amount: balanceRequest.amount,
									type: balanceRequest.type,
									status: balanceRequest.status,
									createdBy: balanceRequest.createdBy,
									category: PendingRequestTypes.BALANCES,
									transactionType: PendingActivityTypes.addBalance,
									currency: balanceRequest.currency,
									depositType: balanceRequest.depositType,
								};

								if (
									_.includes(
										[StatusType.Pending, StatusType.PendingBoSignerReview],
										balanceRequest.status
									)
								) {
									openRequests[category] = [...openRequests[category], obj];
								}
								allRequests[category] = [...allRequests[category], obj];
							});
							break;
						}
						case 'withdrawal': {
							requests[category].forEach((balanceRequest) => {
								let obj = {
									id: balanceRequest.id,
									referenceNumber: balanceRequest.reference,
									date: balanceRequest.createdAt,
									amount: balanceRequest.amount,
									type: balanceRequest.type,
									status: balanceRequest.status,
									createdBy: balanceRequest.createdBy,
									category: PendingRequestTypes.WITHDRAWAL,
									transactionType: PendingActivityTypes.addBalance,
									currency: balanceRequest.currency,
									depositType: balanceRequest.depositType,
								};

								if (
									_.includes(
										[StatusType.Pending, StatusType.PendingBoSignerReview],
										balanceRequest.status
									)
								) {
									openRequests[category] = [...openRequests[category], obj];
								}
								allRequests[category] = [...allRequests[category], obj];
							});
							break;
						}
						case 'beneficiariesRequests': {
							requests[category].forEach((beneficiaryRequest) => {
								let obj = {
									id: beneficiaryRequest.id,
									referenceNumber: beneficiaryRequest.reference,
									date: beneficiaryRequest.createdAt,
									companyName: beneficiaryRequest.companyName,
									currency: beneficiaryRequest.currencyId,
									status: beneficiaryRequest.status,
									country: beneficiaryRequest.countryId,
									type: beneficiaryRequest.type,
									createdBy: beneficiaryRequest.createdBy,
									category: PendingRequestTypes.BENEFICIARIES,
								};
								if (_.isEqual(beneficiaryRequest.status, BeneficiaryStatus.SignedPendingBOApproval)) {
									openRequests[category] = [...openRequests[category], obj];
								}
								if (_.isEqual(beneficiaryRequest.status, BeneficiaryStatus.PendingSigning)) {
									awaitingAuthorization[category] = [...awaitingAuthorization[category], obj];
								}
								allRequests[category] = [...allRequests[category], obj];
							});
							break;
						}
						case 'paymentRequests': {
							requests[category].forEach((paymentRequest) => {
								if (_.isEqual(paymentRequest.status, PaymentStatus.AwaitingAltshulerAuthorization)) {
									openRequests[category] = [
										...openRequests[category],
										{ ...paymentRequest, category: PendingRequestTypes.PAYMENTS },
									];
								} else {
									awaitingAuthorization[category] = [
										...awaitingAuthorization[category],
										{ ...paymentRequest, category: PendingRequestTypes.PAYMENTS },
									];
								}
								allRequests[category] = [
									...allRequests[category],
									{
										...paymentRequest,
										category: PendingRequestTypes.PAYMENTS,
										date: paymentRequest.createdAt,
									},
								];
							});
							break;
						}
						case 'contactRequests': {
							requests[category].forEach((contactRequest) => {
								if (_.isEqual(contactRequest.status, ContactStatus.Pending)) {
									const obj = {
										reference: contactRequest.reference,
										name: contactRequest.firstName + ' ' + contactRequest.lastName,
									};
									openRequests[category] = [...openRequests[category], obj];
								}
							});
							break;
						}
					}
				});
				dispatch(setAll(allRequests));
				dispatch(setAwaitingAuthorization(awaitingAuthorization));
				dispatch(setOpenPending(openRequests));
				dispatch(setLoading(false));
			})
			.catch((error) => {
				console.log(error);
				setTimeout(() => {
					dispatch(setLoading(false));
					dispatch(setOpenPending({}));
					dispatch(setAwaitingAuthorization({}));
					setErrorMessage(setMessage, error);
				}, 500);
			});
	};
}
